<script setup lang="ts">
import type { NounClass, NounConvention } from '~/src/nouns.ts';

defineProps<{
    nounClass: NounClass & { key: string };
    nounConvention: NounConvention;
}>();
</script>

<template>
    <div class="col-6 col-md-3 ">
        <NounsClassExample :noun-class :noun-convention />
        <NounsClassExample :noun-class :noun-convention plural />
    </div>
</template>
